import {
  RootNavigation,
  ResumeFsm,
  NoResumeFsm,
  LoginNavigation,
  WelcomeNavigation,
  RegisterNavigation,
  LoggingIn,
  LoggedIn,
  LoginFailure,
  Logout,
  LogoutRequest,
  RequestSaveFsm,
  SaveFsm,
  RequestRegistration,
  RegistrationFailure,
  RegistrationSuccess,
  Continue,
  RequestPasswordResetNavigation,
  PasswordResetNavigation,
  ConfirmRegistrationNavigation,
  ConfirmPasswordResetNavigation,
  VerifyNurseNavigation
} from '@/store/modules/fsm/messages';

import * as mutations from  '@/mutation-types';
import { LoggedOut, setAllWatches } from '@/mutation-types';;
import router from '@/router/index';
import { THUMB } from '@/api/env.js';
import { post } from '@/store/modules/fsm/index';

let { LoggedIn:LoggedInMutation } = mutations;

export default ({tree,parent,api}) => {
  if(!tree) {
    let { addState, addRegion, PseudoStateKind } = api;
    let here = addRegion('login',parent);
    addState('init',here,PseudoStateKind.Initial);
    addState('thumbIn',here,PseudoStateKind.Junction);
    addState('requestingInitialMessage',here);
    addState('thumbPrompt',here);
    addState('loginPrompt',here);
    addState('registerPrompt',here);
    addState('verifyRegisterationPrompt',here);
    addState('verifyPasswordPrompt',here);
    addState('verifyNursePrompt', here)
    addState('requestResetPasswordPrompt',here);
    addState('resetPasswordPrompt',here);
    addState('registering',here);
    addState('registerSuccess',here);
    addState('registerFailure',here);
    addState('loggingIn',here);
    addState('loggedIn',here);
    addState('logoutRequested',here);
    addState('thumbOut',here,PseudoStateKind.Junction);
  }
  else {
    let { messageIs, messageIsNot, nextRouterHook, navigate } = api;
    let here = parent.login;
    here.init
      .to(here.thumbIn);
    here.thumbIn
      .to(here.thumbPrompt)
      .when(()=>false);
    here.thumbIn
      .to(here.requestingInitialMessage)
      .else()
    /*  .effect(
        (function() {
          let params = router.currentRoute.params;
          params = JSON.parse(JSON.stringify(params));
          console.dir(params);
          let z = router.currentRoute;
          z = JSON.parse(JSON.stringify(z));
          console.dir(z);
          console.dir(router);
          let x = router.currentRoute.params.selectedPdf === undefined ?
          {} : { selectedPdf: Number(router.currentRoute.params.selectedPdf) };
          console.dir(router);
          console.dir(x);
          return x;
         })()) */
      .effect( ({context})=>context.dispatch({type:'login/getInitialMessage'},{root:true}));
    here.requestingInitialMessage
      .to()
      .when(messageIs(RootNavigation))
      .effect(nextRouterHook);
    here.requestingInitialMessage
      .to(here.loginPrompt)
      .when(messageIs(NoResumeFsm))
      .effect((instance) => {
        // console.dir(router)
        if (router.currentRoute != undefined && router.currentRoute.name  === VerifyNurseNavigation)
        {}
        else if(router.currentRoute === undefined || router.currentRoute.name === undefined
          || router.currentRoute.name !== LoginNavigation)
        {
          navigate(LoginNavigation)(instance);
        }
        else
        {
        }
      });
    here.loginPrompt
      .to(here.loginPrompt)
      .when(messageIs(LoginNavigation))
      .effect(nextRouterHook);
    here.loginPrompt
      .to(here.requestResetPasswordPrompt)
      .when(messageIs(RequestPasswordResetNavigation))
      .effect(nextRouterHook);
    here.requestResetPasswordPrompt
      .to(here.loginPrompt)
      .when(messageIs(LoginNavigation))
      .effect(nextRouterHook);
    here.loginPrompt
      .to(here.resetPasswordPrompt)
      .when(messageIs(PasswordResetNavigation))
      .effect(nextRouterHook);
    here.loginPrompt
      .to(here.verifyNursePrompt)
      .when(messageIs(VerifyNurseNavigation))
      .effect(navigate(VerifyNurseNavigation))
    here.resetPasswordPrompt
      .to(here.loginPrompt)
      .when(messageIs(LoginNavigation))
      .effect(nextRouterHook);
    here.resetPasswordPrompt
      .to(here.requestResetPasswordPrompt)
      .when(messageIs(RequestPasswordResetNavigation))
      .effect(nextRouterHook);
    here.requestingInitialMessage
      .to(here.verifyRegisterationPrompt)
      .when(messageIs(ConfirmRegistrationNavigation))
      .effect(nextRouterHook);
    here.requestingInitialMessage
      .to(here.verifyPasswordPrompt)
      .when(messageIs(ConfirmPasswordResetNavigation))
      .effect(nextRouterHook);
      
    here.loginPrompt
      .to(here.verifyRegisterationPrompt)
      .when(messageIs(ConfirmRegistrationNavigation))
      .effect(nextRouterHook);

    here.verifyRegisterationPrompt
      .to(here.loginPrompt)
      .when(messageIs(LoginNavigation))
      .effect(nextRouterHook);
    here.loginPrompt
      .to(here.verifyNursePrompt)
      .when(messageIs(VerifyNurseNavigation))
      .effect(nextRouterHook)
    here.loginPrompt
      .to(here.registerPrompt)
      .when(messageIs(RegisterNavigation))
      .effect(nextRouterHook);
    here.thumbIn
      .to(here.verifyRegistrationPrompt)
      .when(messageIs(ConfirmRegistrationNavigation))
      .effect(nextRouterHook);
    here.registerPrompt
      .to(here.loginPrompt)
      .when(messageIs(LoginNavigation))
      .effect(nextRouterHook);
    here.registerPrompt
      .to(here.registering)
      .when(messageIs(RequestRegistration));
    here.registering
      .to(here.registerSuccess)
      .when(messageIs(RegistrationSuccess))
      .effect(()=>{
        post({ message: Continue });
      });
    here.registering
      .to(here.registerFailure)
      .when(messageIs(RegistrationFailure))
      .effect(()=>{
        post({ message: Continue });
      });
    here.registerFailure
      .to(here.registerPrompt)
      .when(messageIs(Continue));
    here.registerSuccess
      .to(here.loginPrompt)
      .when(messageIs(Continue))
      /* NOTE: while redirecting to login page is fine for the current 
        implementation of the application 
        
        the correct way to go is:
        
        whenever the fsm is in 'loginPrompt' or other states indicating the 
        application's location, that particular state alone should be doing
        redirection, any transitions to that state won't be doing page 
        redirection in its 'effect' call back
      */
      .effect(navigate(LoginNavigation));
    here.loginPrompt
      .to(here.loggingIn)
      .when(messageIs(LoggingIn))
      .effect(({context},{loader, patient, password,LoginPage})=> {
         context.dispatch({type:'login/login',loader,patient,password,LoginPage},{root:true})
          .then();
      });
    here.loggingIn
      .to(here.loggedIn)
      .when(messageIs(LoggedIn))
      .effect(({context},{data})=>context.commit(`login/${LoggedInMutation}`,{data},{root:true}))
      .effect(navigate(WelcomeNavigation))
      .effect(({context},{watch}) => watch ? context.commit(`login/watch/${setAllWatches}`,watch,{root:true}) : 0);
    here.loggingIn
      .to(here.loginPrompt)
      .when(messageIs(LoginFailure));
    here.loggedIn
      .to(here.logoutRequested)
      .when(messageIs(LogoutRequest))
      .effect(({context})=> {
        post({message:Logout});
        context.dispatch('login/logout',null,{root:true}).then(()=>{
          navigate(LoginNavigation)();
        });
      });
    here.logoutRequested
      .to(here.thumbOut)
      .when(messageIs(Logout));
    here.loggedIn
      .to()
      .when(messageIs(LoginNavigation))
      .effect(({}={},{next})=>  next(false) );
    here.loggedIn
      .to()
      .when(messageIs(ResumeFsm))
      .effect(({context},{watch}) => watch ? context.commit(`login/watch/${setAllWatches}`,watch,{root:true}) : 0)
      .effect(({context},message)=>context.commit(`login/${LoggedInMutation}`,{...message},{root:true}));
    here.loggedIn
      .to()
      .when(messageIs(RequestSaveFsm))
      .effect(()=>post({message:SaveFsm,toString:()=>SaveFsm}));
    here.thumbOut
      .to(here.thumbPrompt)
      .when(()=>THUMB)
      .effect(({context})=>context.dispatch({type:'ShowThumbLogin'}));
    here.thumbOut
      .to(here.loginPrompt)
      .else()
      .effect(({context})=>context.dispatch({type:'login/showLoginPrompt'},{root:true}));
  }
}      
